import React from 'react';
import { useTranslation } from 'react-i18next';

import { getProcessMethodDisplay } from '../../utils/processTypeUtils';

type ProcessMethodBadgeProps = {
  processType?: unknown;
  variant?: 'home' | 'library';
};

const ProcessMethodBadge: React.FC<ProcessMethodBadgeProps> = ({ processType, variant = 'home' }) => {
  const { t } = useTranslation();
  const display = getProcessMethodDisplay(processType);

  if (variant === 'library') {
    return (
      <span className={`lib-p-type-${display.badgeClassSuffix}`}>
        {t(display.labelKey, { defaultValue: 'Process mapping' })}
      </span>
    );
  }

  return (
    <span className={`home-p-type-flag home-p-type-flag--${display.badgeClassSuffix}`}>
      {t(display.labelKey, { defaultValue: 'Process mapping' })}
    </span>
  );
};

export default ProcessMethodBadge;
